export default __webpack_public_path__ + "static/media/menu-dispatch-elipsis.612fb51d.svg";